import React from "react";
import PageLayout from "../../atoms/page-layout";
import AcceptInvitationHeader from "../../molecules/app-bars/accept-invitation";
import AcceptInvitationForm from "../../organisms/accept-invitation-form";
import { useGetParams } from "../../utils/hooks/useGetParams";
import FullPageLoading from "../../atoms/full-page-loading";
import { useInvitationValidation } from "../../utils/hooks/project-expert/useInvitationValidation";
import MessageDisplay from "../../atoms/message-display";

export default function AcceptInvitation() {
  const id = useGetParams("id");
  const { data, isLoading, error } = useInvitationValidation(id);

  // Render loading state
  if (isLoading) {
    return <FullPageLoading />;
  }

  // Render error state
  if (error) {
    return (
      <PageLayout>
        <AcceptInvitationHeader />
        <MessageDisplay
          title={error.title}
          message={error.message}
          showDashboardLink={error.showDashboardLink}
        />
      </PageLayout>
    );
  }

  // Render success state with form
  return (
    <PageLayout>
      <AcceptInvitationHeader />
      {id && data && (
        <AcceptInvitationForm
          id={id}
          isInvitationAccepted={data.isInvitationAccepted}
          share_agenda={data.isAgendaShared}
          projectId={data.project_id}
          userId={data.user_id}
          peId={data.pe_id}
          expertId={data.expert_id}
        />
      )}
    </PageLayout>
  );
}